import { Po } from './po';
import { Piece } from '../../inventory/piece';

// A PO can be for a supplier purchase or a branch to branch transfer, both are shown in the same list.
export class PoBranch extends Po {
  notes: string;;
    source_branch_id: number;
    source_branch_name: string;
    source_branch_code: string;
    order_date: string;    
    transferItems: Piece[];
}


// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/purchasing/pos/poBranch.ts